import { useLanguage } from "@/context/LanguageContext";
import { ASSETS } from "@/data/content";
import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";

export default function Profile() {
  const { t } = useLanguage();
  const p = t.perfil;

  return (
    <section id="perfil" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-20 sm:px-6 sm:py-28 lg:px-8" data-testid="perfil-section">
      <SectionHeader number={`${p.number} · ${t.nav.perfil}`} title={p.title} />

      <div className="grid gap-10 lg:grid-cols-12 lg:gap-14">
        <Reveal className="lg:col-span-5">
          <div className="group relative overflow-hidden rounded-2xl border border-white/10">
            <img
              src={ASSETS.portrait}
              alt="Retrato de Adrián Cuadra en partido con Deportes Antofagasta"
              className="aspect-[4/5] w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
              loading="lazy"
            />
            <span className="absolute left-4 top-4 rounded-full bg-[#07090E]/70 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-sky-300 backdrop-blur-sm">
              {p.photoTag}
            </span>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <p className="max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">{p.intro}</p>
          </Reveal>

          <Reveal delay={0.15}>
            <dl className="mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-white/10 bg-white/5 sm:grid-cols-2" data-testid="perfil-data-grid">
              {p.data.map((d) => (
                <div key={d.label} className="bg-[#0E131F] p-4 sm:p-5">
                  <dt className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">
                    {d.label}
                  </dt>
                  <dd className="mt-1.5 text-sm font-semibold text-slate-100">{d.value}</dd>
                  {d.src && <dd className="mt-0.5 text-[10px] uppercase tracking-wider text-slate-500">{d.src}</dd>}
                </div>
              ))}
            </dl>
          </Reveal>
        </div>
      </div>

      <div className="mt-16">
        <Reveal>
          <h3 className="mb-6 font-display text-xl font-bold uppercase tracking-wide text-slate-200 sm:text-2xl">
            {p.traitsTitle}
          </h3>
        </Reveal>
        <div className="grid gap-4 sm:grid-cols-2" data-testid="perfil-traits-grid">
          {p.traits.map((tr, i) => (
            <Reveal key={tr.title} delay={0.08 * i}>
              <article className="h-full rounded-xl border border-white/10 bg-[#0E131F] p-6 transition-colors duration-300 hover:border-sky-400/40">
                <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-sky-400/80">
                  {tr.tag}
                </p>
                <h4 className="mt-3 font-display text-lg font-bold uppercase tracking-wide text-white">
                  {tr.title}
                </h4>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{tr.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-6 text-xs leading-relaxed text-slate-500">{p.note}</p>
        </Reveal>
      </div>
    </section>
  );
}
